import {VariantType} from '~/GalleryPB/Template/components/QuickView/types';
import {Typography} from '~library/atoms/Typography';

import './Content.sass';

export type ContentProps = {
  variant: VariantType;
};

export const Content = ({variant}: ContentProps) => {
  const title =
    variant === VariantType.PREMIUM ? 'What you get with Premium:' : 'Level up to Premium and get:';

  return (
    <div className="quick-view__content">
      <Typography variant="paragraph2">{title}</Typography>

      <ul className="quick-view__content__list">
        <li>
          <Typography variant="paragraph2" as="span">
            Animated effects and reveals
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph2" as="span">
            Ad-free experience
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph2" as="span">
            Host photo gallery
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph2" as="span">
            Option to remove Evite’s curated gift guides from your Invitation
          </Typography>
        </li>
        <li>
          <Typography variant="paragraph2" as="span">
            Customize backgrounds, envelopes and stickers
          </Typography>
        </li>
      </ul>
    </div>
  );
};
